<div class="section-ctnr">
    <div class="page-description">
        <fa-icon [icon]="faIconName.faInfoCircle" class="description-icon"></fa-icon>
        This section will list all system emails that you may receive. You will only receive emails if you are the
        recipient as defined by each email routine. Administrators may modify the types of emails you can receive.
        Certain emails are required and are not displayed below.
    </div>

    @if (model$ | async) {
        <form pcgSubmitUrl="api/Administration/Users/SaveUserNotifications" [formGroup]="formGroup" class="mb-4">
            <input type="hidden" formControlName="userNotificationId" />
            <input type="hidden" formControlName="userId" />
            <div class="notifications-ctnr">
                <!-- All Notifications -->
                @if (isAdmin) {
                    <div class="notification-row bb">
                        <div class="notification-head">
                            <mat-slide-toggle
                                type="checkbox"
                                class="mr-3"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="isSubscribedToAll"
                                (change)="subscribeAll()"
                            ></mat-slide-toggle>
                            <h6>All Notifications</h6>
                        </div>
                        <div class="notification-body">
                            <p>Subscribe or unsubscribe from all notifications at once.</p>
                        </div>
                    </div>
                }
                <!-- Inventory Count -->
                <div class="notification-row">
                    <div class="notification-head">
                        @if (isAdmin) {
                            <mat-slide-toggle
                                type="checkbox"
                                [checked]="model.dailyCount"
                                class="mr-3"
                                (change)="model.dailyCount = !model.dailyCount; saveForm()"
                            ></mat-slide-toggle>
                        }
                        @if (!isAdmin) {
                            <a
                                class="noClick btn form-control disabled-btn mr-3"
                                [ngClass]="model.dailyCount ? 'green-text' : 'text-danger'"
                                >{{ model.dailyCount ? 'Subscribed' : 'Unsubscribed' }}</a
                            >
                        }
                        <h6>Inventory Count</h6>
                    </div>
                    <div class="notification-body">
                        <p>
                            When checked, receive notifications when an inventory count is planned for an associated
                            site.
                        </p>
                    </div>
                </div>
                <!-- Missed Inventory Count -->
                <div class="notification-row">
                    <div class="notification-head">
                        @if (isAdmin) {
                            <mat-slide-toggle
                                type="checkbox"
                                [checked]="model.missedDailyCount"
                                class="mr-3"
                                (change)="model.missedDailyCount = !model.missedDailyCount; saveForm()"
                            ></mat-slide-toggle>
                        }
                        @if (!isAdmin) {
                            <a
                                class="noClick btn form-control disabled-btn mr-3"
                                [ngClass]="model.missedDailyCount ? 'green-text' : 'text-danger'"
                                >{{ model.missedDailyCount ? 'Subscribed' : 'Unsubscribed' }}</a
                            >
                        }
                        <h6>Missed Inventory Count</h6>
                    </div>
                    <div class="notification-body">
                        <p>When checked, receive notifications about missing inventory counts for associated sites.</p>
                    </div>
                </div>
                <!-- Business Day Reminder -->
                <div class="notification-row">
                    <div class="notification-head">
                        @if (isAdmin) {
                            <mat-slide-toggle
                                type="checkbox"
                                [checked]="model.businessDaysReminder"
                                class="mr-3"
                                (change)="model.businessDaysReminder = !model.businessDaysReminder; saveForm()"
                            ></mat-slide-toggle>
                        }
                        @if (!isAdmin) {
                            <a
                                class="noClick btn form-control disabled-btn mr-3"
                                [ngClass]="model.businessDaysReminder ? 'green-text' : 'text-danger'"
                                >{{ model.businessDaysReminder ? 'Subscribed' : 'Unsubscribed' }}</a
                            >
                        }
                        <h6>Business Days Reminder</h6>
                    </div>
                    <div class="notification-body">
                        <p>
                            When checked, receive notifications for each day a site doesn't have any business days
                            scheduled as Open.
                        </p>
                    </div>
                </div>
            </div>
        </form>
    }
</div>
